import {useContext, useState} from "react";
import {BrowserRouter as Router, Link, Route, Routes, Navigate} from "react-router-dom";
import {PDivider, PLinkPure} from "@porsche-design-system/components-react";
import MissingPage from "../pages/MissingPage";
import {getRoutes} from "../route";
import "./AppMain.scss";
import UserContext, {UserContextType} from "../store/UserContext";
import { Grid } from "@react-css/grid";

function AppMain() {
    const {roles} = useContext<UserContextType>(UserContext);
    const routes = getRoutes(roles)
    const [curPath, handleCurrentPath] = useState(window.location.pathname === "/" ? routes[0].path : window.location.pathname);

    function handleMenuClick() {
        const pathname = window.location.pathname;
        handleCurrentPath(pathname);
    }

    return (
        <div className="app-main">
            <Router>
                <Grid autoFlowColumn gap={'0.5em'} columns='[first] 15% [line2] 85%'>
                    <Grid.Item>
                        <Grid >
                            {routes.map((route) => (
                                <Grid.Item  key={route.path}>
                                    <PLinkPure className="AppNavItem" autoFocus={false} active={curPath === route.path}
                                               onClick={() => handleMenuClick()} inert={false}>
                                        <Link to={route.path} children={route.name}/>
                                    </PLinkPure>
                                    <PDivider className="AppMain-divider" autoFocus={false} inert={false}/>
                                </Grid.Item>
                            ))}
                        </Grid>
                    </Grid.Item>
                    <Grid.Item >
                        <Routes>
                            {routes.map((route, index) => {
                                return <Route key={index} path={route.path} element={route.element}/>;
                            })}
                            <Route path="/">
                                <Route path="/" element={<Navigate to={routes[0].path}/>}/>
                            </Route>
                            <Route path="/" element={<MissingPage/>}/>
                        </Routes>
                    </Grid.Item>
                </Grid>
            </Router>
        </div>
    );
}

export default AppMain;
